import { VerticalLayout } from "ds_legacy/materials/layouts";
import { padding, sizing } from "ds_legacy/materials/metrics";
import { GAP, Section } from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";
import { AftercareApplication } from "./AftercareApplication";
import { AftercareCarelevel } from "./AftercareCarelevel";
import { AftercareTypes } from "./AftercareTypes";

export const SectionC = () => {
  const translations = useTranslations();
  return (
    <Section
      title={translations.patientForms.transitionalCareForm.sectionC.title}
    >
      <VerticalLayout
        gap={sizing(GAP)}
        overflow="visible"
        padding={padding(GAP, 0, 0)}
      >
        <AftercareTypes />
        <AftercareApplication />
        <AftercareCarelevel />
      </VerticalLayout>
    </Section>
  );
};
